module.exports = __webpack_public_path__ + "static/media/key_icon_black.2f676de1.svg";